import { Directive, Injector, Optional } from '@angular/core';
import { DISPLAY_TYPE, IWidgetConfig, StylableComponent, provideAsWidgetRef, Parent, register, styler } from "@wm/components-base";

const DEFAULT_CLS = 'app-partial clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-partial',
  hostClass: DEFAULT_CLS
};

// Map widget types to CSS classes
const TYPE_CLASS_MAP: Record<string, string> = {
  leftnav: 'app-left-panel',
  rightnav: 'app-right-panel',
  header: 'app-header',
  footer: 'app-footer',
  topnav: 'app-top-nav'
};

@Directive({
  selector: '[wmPartial]',
  providers: [provideAsWidgetRef(PartialDirective)],
  standalone: true,
  exportAs: 'wmPartial'
})
export class PartialDirective extends StylableComponent {
  static initializeProps = register('wm-partial');

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
  }

  /** React to property changes */
  override onPropertyChange(key: string, nv: any, ov?: any) {
    if (key === 'type' || key === 'partialtype') {
      this.applyPartialClass(nv);
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }

  override ngOnInit() {
    super.ngOnInit();
    const type = this.$attrs?.get('partialtype') || this.$attrs?.get('type');
    this.applyPartialClass(type);
  }

  /** Core logic: apply/remove classes */
  private applyPartialClass(type?: string) {
    // Remove all type-related classes first
    Object.values(TYPE_CLASS_MAP).forEach(cls =>
      this.nativeElement.classList.remove(cls)
    );

    // If inside a wmpage, stop here (don’t add any class)
    if (this.nativeElement.closest('[wmpage]')) {
      return;
    }

    // Otherwise add the class if it's a valid type + has wmpartial
    if (
      this.nativeElement.hasAttribute('wmpartial') &&
      type &&
      TYPE_CLASS_MAP[type]
    ) {
      this.nativeElement.classList.add(TYPE_CLASS_MAP[type]);
    }
  }
}